import * as _ from 'lodash';
import { Col, ControlLabel, FormControl, FormGroup, Glyphicon } from 'react-bootstrap';
import { OverlayTrigger } from 'react-bootstrap';
import PopoverTemplate from '@nkr/components/popover-template';
import YesNoUnknown from '../yes-no-unknown';
import { FormEvent } from 'react';
import { IDonorProfileMedicalDetailsData } from '@nkr/models/donor-profile';

interface IProps {
    data: IDonorProfileMedicalDetailsData,
    whichKidney: string,
    kidneyHeight: number,
    kidneyLength: number,
    kidneyWidth: number,
    kidneyVolume: number,
    numberOfVeins: number,
    numberOfArteries: number,
    numberOfUreters: number,
    hasEarlyBifurcation: boolean,
    earlyBifurcationLength: number,
    whichKidneyList: { id: string, description: string }[],
    onChange: (data: IDonorProfileMedicalDetailsData) => void
}

const KidneyInfo = (props: IProps) => {
    const handleTextChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        let data = _.cloneDeep(props.data);

        data[name] = value;

        props.onChange(data);
    };

    const handleSelectNumberChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        let name = e.currentTarget.name;
        let value: null | number = null;

        if (e.currentTarget.value != null) {
            value = parseInt(e.currentTarget.value);
        }

        let data = _.cloneDeep(props.data);

        data[name] = value;

        props.onChange(data);

    };

    const handleNumberChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        let data = _.cloneDeep(props.data);

        data[name] = parseFloat(value);

        props.onChange(data);
    }

    const handleOnlyIntChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        let data = _.cloneDeep(props.data);

        data[name] = parseInt(value);

        props.onChange(data);
    }

    const handleBooleanChange = (name: string, value: boolean) => {
        let data = _.cloneDeep(props.data);

        data[name] = value;

        props.onChange(data);
    };

    const numberOfVeins = _.range(1, 5);
    const numberOfArteries = _.range(1, 9);
    const numberOfUreters = _.range(1, 4);
    const earlyBifurcationLength = _.range(1, 101);

    return (
        <>
            <FormGroup>
                <Col xs={12} lg={5} componentClass={ControlLabel}>Kidney to be donated:</Col>
                <Col xs={12} lg={7}>
                    <FormControl
                        componentClass='select'
                        name='whichKidney'
                        value={props.whichKidney}
                        onChange={handleTextChange}
                    >
                        <option value={null}>- Select -</option>
                        {props.whichKidneyList.filter(item => item.id !== 'DNK').map(item =>
                            <option key={'da-' + item.id} value={item.id}>{item.description}</option>
                        )}
                    </FormControl>
                </Col>
            </FormGroup>

            <FormGroup>
                <Col xs={12}>
                    <span style={{ display: 'inline-block', border: '1px solid #ddd', borderRadius: 4, padding: '4px 10px' }}>
                        <ControlLabel style={{ marginBottom: 0 }}>
                            Functional Anatomy
                            <OverlayTrigger trigger='hover' placement='top' rootClose overlay={
                                <PopoverTemplate>
                                    The final post-procurement anatomy of the donor kidney as it will be received and implanted by the recipient center.
                                </PopoverTemplate>
                            }>
                                <Glyphicon glyph='info-sign' style={{ marginLeft: 6, cursor: 'pointer' }} />
                            </OverlayTrigger>
                        </ControlLabel>
                    </span>
                </Col>
            </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={5} componentClass={ControlLabel}>Number of Veins:</Col>
                    <Col xs={12} lg={7}>
                        <FormControl
                            componentClass='select'
                            name='numberOfVeins'
                            value={props.numberOfVeins}
                            onChange={handleSelectNumberChange}
                        >
                            <option value='-1'>- Select -</option>
                            {numberOfVeins.map(n =>
                                <option key={'nv-' + n} value={n}>{n}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={5} componentClass={ControlLabel}>Number of Arteries:</Col>
                    <Col xs={12} lg={7}>
                        <FormControl
                            componentClass='select'
                            name='numberOfArteries'
                            value={props.numberOfArteries}
                            onChange={handleSelectNumberChange}
                        >
                            <option value='-1'>- Select -</option>
                            {numberOfArteries.map(n =>
                                <option key={'nv-' + n} value={n}>{n}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={5} componentClass={ControlLabel}>Number of Ureters:</Col>
                    <Col xs={12} lg={7}>
                        <FormControl
                            componentClass='select'
                            name='numberOfUreters'
                            value={props.numberOfUreters}
                            onChange={handleSelectNumberChange}
                        >
                            <option value='-1'>- Select -</option>
                            {numberOfUreters.map(n =>
                                <option key={'nv-' + n} value={n}>{n}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>
            <FormGroup>
                <Col xs={12} lg={5} componentClass={ControlLabel}>Kidney CT/US <span className='small_descr'>(height in cm):</span></Col>
                <Col xs={12} lg={7}>
                    <FormControl
                        id='KidneyHeight'
                        type='number'
                        name='kidneyHeight'
                        value={props.kidneyHeight}
                        onChange={handleNumberChange}
                        className='form-control'
                    />
                </Col>
            </FormGroup>

            <FormGroup>
                <Col xs={12} lg={5} componentClass={ControlLabel}>Kidney CT/US <span className='small_descr'>(length in cm):</span></Col>
                <Col xs={12} lg={7}>
                    <FormControl
                        id='KidneyLength'
                        type='number'
                        name='kidneyLength'
                        value={props.kidneyLength}
                        onChange={handleNumberChange}
                        className='form-control'
                    />
                </Col>
            </FormGroup>

            <FormGroup>
                <Col xs={12} lg={5} componentClass={ControlLabel}>Kidney CT/US <span className='small_descr'>(width in cm):</span></Col>
                <Col xs={12} lg={7}>
                    <FormControl
                        id='KidneyWidth'
                        type='number'
                        name='kidneyWidth'
                        value={props.kidneyWidth}
                        onChange={handleNumberChange}
                        className='form-control'
                    />
                </Col>
            </FormGroup>

            <FormGroup>
                <Col xs={12} lg={5} componentClass={ControlLabel}>Kidney 3D-CT <span className='small_descr'>(volume in cc):</span></Col>
                <Col xs={12} lg={7}>
                    <FormControl
                        id='KidneyVolume'
                        className='form-control'
                        type='number'
                        name='kidneyVolume'
                        value={props.kidneyVolume}
                        onChange={handleOnlyIntChange}
                    />
                </Col>
            </FormGroup>

            <FormGroup>
                <Col xs={12} lg={5} componentClass={ControlLabel}>Has Early Bifurcation?</Col>
                <Col xs={12} lg={7}>
                    <YesNoUnknown
                        name='hasEarlyBifurcation'
                        yes={props.hasEarlyBifurcation == true}
                        no={props.hasEarlyBifurcation == false}
                        unknown={props.hasEarlyBifurcation == null}
                        onChange={handleBooleanChange}
                    />
                </Col>
            </FormGroup>

            <FormGroup>
                <Col xs={12} lg={5} componentClass={ControlLabel}>Early Bifurcation Length (in mm)?</Col>
                <Col xs={12} lg={7}>
                    <FormControl
                        componentClass='select'
                        name='earlyBifurcationLength'
                        value={props.earlyBifurcationLength}
                        onChange={handleSelectNumberChange}
                    >
                        <option value='-1'>- Select -</option>
                        {earlyBifurcationLength.map(n =>
                            <option key={'nv-' + n} value={n}>{n}</option>
                        )}
                    </FormControl>
                </Col>
            </FormGroup>
        </>
    );
}

export default KidneyInfo;